import { useMutation, useQueryClient } from '@tanstack/react-query';
import { deleteTenantSubject } from '@services/registry';

export function useDeleteTenantSubject({ tenantId }) {
    const qc = useQueryClient();
    return useMutation({
        mutationFn: async ({ subjectId }) => {
            return await deleteTenantSubject({ tenantId, subjectId });
        },
        onSuccess: () => {
            qc.invalidateQueries({ queryKey: ['tenantSubjects', tenantId] });
        },
    });
}

